module.exports = __webpack_public_path__ + "static/media/qswebMobile.b91f704d.png";